(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["faq"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-faq-toggle]').forEach((toggle) => {
      toggle.addEventListener('click', () => {
        const item = toggle.closest('[data-faq-item]');
        const answer = item.querySelector('[data-faq-answer]');
        const icon = item.querySelector('[data-faq-icon]');
        const isOpen = !answer.hasAttribute('hidden');

        // Close all others
        document.querySelectorAll('[data-faq-answer]').forEach((el) => el.setAttribute('hidden', true));
        document.querySelectorAll('[data-faq-icon]').forEach((el) => {
          el.src = el.dataset.iconDown;
        });

        if (!isOpen) {
          answer.removeAttribute('hidden');
          icon.src = icon.dataset.iconUp;
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const hamburger = document.querySelector('.hamburger');
    const mobileMenu = document.getElementById('mobileMenu');
    const closeMenu = document.getElementById('closeMenu');

    hamburger.addEventListener('click', () => {
      mobileMenu.classList.add('active');
      hamburger.setAttribute('aria-expanded', 'true');
    });

    closeMenu.addEventListener('click', () => {
      mobileMenu.classList.remove('active');
      hamburger.setAttribute('aria-expanded', 'false');
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ideas"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const grid = document.querySelector('.ideas-grid');
    const leftArrow = document.querySelector('.carousel-arrow.left');
    const rightArrow = document.querySelector('.carousel-arrow.right');

    if (!grid || !leftArrow || !rightArrow) return;

    const card = grid.querySelector('.ideas-card');
    if (!card) return;

    const gap = 32; // 2rem
    let cardWidth = 0;

    function updateArrows() {
      const maxScroll = grid.scrollWidth - grid.clientWidth;
      leftArrow.disabled = grid.scrollLeft <= 0;
      rightArrow.disabled = grid.scrollLeft >= maxScroll - 5;
    }

    rightArrow.addEventListener('click', () => {
      grid.scrollBy({ left: cardWidth, behavior: 'smooth' });
      setTimeout(updateArrows, 400);
    });

    leftArrow.addEventListener('click', () => {
      grid.scrollBy({ left: -cardWidth, behavior: 'smooth' });
      setTimeout(updateArrows, 400);
    });

    grid.addEventListener('scroll', updateArrows);

    // Defer geometry reads until after first paint to avoid forced reflow
    requestAnimationFrame(function () {
      cardWidth = card.offsetWidth + gap;
      updateArrows();
    });
  });

  } catch(e) { console.error(e); }
})();
})();
